import React from 'react'
import { useFeatureFlag } from '@fs/zion-flags'
import { ThingMapPin } from '@fs/zion-icon'
import { baseUrl } from '@fs/zion-config'
import { useTranslation } from 'react-i18next'
import { i18n } from '@fs/zion-locale'
import HeaderIconButton from '../../../shared/components/HeaderIconButton'

function getFhcLink({ external, useLocationsPath }) {
  const externalUrl = external ? baseUrl : ''
  if (useLocationsPath) {
    return `${externalUrl}/${i18n.language}/locations/about`
  }
  return `${externalUrl}/${i18n.language}/centers/about`
}

export default function LocationIconButton({ linkName, external }) {
  const { isOn: useLocationsPath } = useFeatureFlag('help_locations_path')
  const { t } = useTranslation()

  return (
    <HeaderIconButton
      Icon={ThingMapPin}
      title={t('header.locations', 'Locations')}
      to={getFhcLink({ external, useLocationsPath })}
      linkName={linkName}
      external
      data-test-id="hdr_FS_Center_Locations"
    />
  )
}
